import React from 'react';

// Erzwungener Watchlist-Wechsel beim Modul-Wechsel innerhalb des Marketdata-
// Bereichs (Watchlist-Verwaltung <-> Live <-> Charts, siehe die "Stift"/
// "Live"/"Charts"-Icons in den jeweiligen Toolbars) - z.B. "Watchlist
// bearbeiten" in Live soll in der Verwaltung dieselbe Watchlist zeigen, statt
// auf die Default-Watchlist zurueckzufallen.
//
// Bewusst als Property direkt auf dem langlebigen "x"-Objekt abgelegt (nicht
// auf x.wam[moduleId]): schliesst der Nutzer ein Modul-Fenster, loescht
// removeModule() x.wam[moduleId] komplett - ein dort abgelegter Callback
// waere dann weg. "x" selbst existiert dagegen fuer die gesamte App-Laufzeit.
//
// setMarketdataForcedGroup(x, groupId) VOR x.wam.activate(zielModulId)
// aufrufen. useMarketdataForcedGroup(x, onForcedGroup) im Zielmodul liefert
// eine "consume"-Funktion, die an ZWEI Stellen aufgerufen werden muss, je
// nachdem ob das Zielmodul beim Wechsel schon gemountet war:
// - Erstes Oeffnen ueberhaupt: im Mount-Effekt (siehe Rueckgabewert unten,
//   wird intern bereits einmalig beim Mounten aufgerufen).
// - Bereits (wieder) gemountet: ueber die "onShow"-Prop von Module.js/
//   ModuleTable.js (wird bei jedem x.wam.activate() erneut aufgerufen).
export function setMarketdataForcedGroup(x, groupId) {
	x.marketdataForcedGroup = { groupId, token: Date.now() };
}

// onForcedGroup({groupId, token}) wird aufgerufen, sobald ein erzwungener
// Wechsel vorliegt - das komplette {groupId, token}-Objekt (nicht nur die Id)
// weiterreichen, damit es direkt als "forcedGroup"-Prop an
// MarketdataGroupSelector durchgereicht werden kann (der Token sorgt dort
// dafuer, dass auch zweimal hintereinander dieselbe Watchlist erzwungen
// werden kann). Gibt "consume" zurueck - diese Funktion an die "onShow"-Prop
// des Zielmoduls haengen (der Mount-Fall wird hier bereits automatisch
// abgedeckt).
export function useMarketdataForcedGroup(x, onForcedGroup) {
	function consume() {
		if (x.marketdataForcedGroup) {
			const forcedGroup = x.marketdataForcedGroup;
			x.marketdataForcedGroup = null;
			onForcedGroup(forcedGroup);
		}
	}

	React.useEffect(() => {
		consume();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return consume;
}
